var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "diaryRow-item", attrs: { align: "center" } },
    [
      _c(
        "column-wrapper",
        [
          _c("first-course", {
            ref: "firstCourse",
            attrs: {
              student: _vm.student,
              title: "1er Plato",
              studentName: _vm.studentName
            },
            on: { updatedElement: _vm.detectElementChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("second-course", {
            ref: "secondCourse",
            attrs: {
              student: _vm.student,
              title: "2º Plato",
              studentName: _vm.studentName
            },
            on: { updatedElement: _vm.detectElementChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("desserts", {
            ref: "dessert",
            attrs: {
              student: _vm.student,
              title: "Postre",
              studentName: _vm.studentName
            },
            on: { updatedElement: _vm.detectElementChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("suggested-dinner", {
            ref: "suggestedDinner",
            attrs: {
              student: _vm.student,
              title: "Cena Sugerida",
              studentName: _vm.studentName
            },
            on: { updatedElement: _vm.detectElementChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a8cdfa3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8cdfa3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryType/MenuDiary/MenuDiaryRow.vue
// module id = 290
// module chunks = 1